import Link from 'next/link';

import { staticCdnHost } from '@rockalingua/ui/constants/Cdn';

import { LogoContainer } from './Logo.styled';

type LogoProps = {
  href?: string;
};

export default function Logo({ href = '/' }: LogoProps) {
  if (href == '#') {
    return (
      <LogoContainer>
        <img
          src={staticCdnHost + '/img/rockaLogo.png'}
          alt="Rockalingua logo"
        />
      </LogoContainer>
    );
  }

  return (
    <LogoContainer>
      <Link href={href}>
        <img
          src={staticCdnHost + '/img/rockaLogo.png'}
          alt="Rockalingua logo"
        />
      </Link>
    </LogoContainer>
  );
}
